import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LangController from "../controllers/LangController";
import Lang from "../models/Lang";

type LangContext = {
    translate(key: string): string;
}

const langContext = React.createContext<LangContext>({} as LangContext);

const LangProvider = ({ children }: { children: React.ReactNode }) => {
    const {lang} = useParams();
    const [langData, setLangData] = useState<Lang>();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if(!lang) return;
        LangController.getLang(lang).then((l) => {
            setLangData(l);
            setLoading(false);
        }).catch((error) => {
            console.error(error);
            setLoading(false);
        });
    }, [lang]);
    
    const translate = (key: string): string => {
        if(!langData) return `local_${lang}_` + key;
        if (key in langData.data) {
            return langData.data[key as keyof typeof langData.data];
        } 
        return `local_${lang}_` + key;
    }

    if(loading) return <p>Loading...</p>;
    return (
        <langContext.Provider value={{translate}}>
            {children}
        </langContext.Provider>
    );   
}

const useLang = () => useContext(langContext);
export { LangProvider, useLang };